module.exports = __webpack_public_path__ + "img/b2c7b2f.png";